import { render, staticRenderFns } from "./index copy 2.vue?vue&type=template&id=6f08057c&scoped=true"
import script from "./index copy 2.vue?vue&type=script&lang=js"
export * from "./index copy 2.vue?vue&type=script&lang=js"
import style0 from "./index copy 2.vue?vue&type=style&index=0&id=6f08057c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f08057c",
  null
  
)

export default component.exports